import { render, staticRenderFns } from "./SubmissionPanel.vue?vue&type=template&id=76820106&"
import script from "./SubmissionPanel.vue?vue&type=script&lang=js&"
export * from "./SubmissionPanel.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionPanel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SubmissionPanel.vue"
export default component.exports